<!--
 * @Author: zhangliang
 * @Date: 2020-03-07 23:08:56
 * @LastEditTime: 2020-03-17 12:35:07
 * @LastEditors: zhangliang
 * @Description: 手风琴折叠面板主体部分
 * @FilePath: \asset_app\src\components\OrgCollapse.vue
 -->
<template>
    <div class="org-collapse">
        <van-collapse 
        v-for="item in orgData" 
        v-model="orgData.id" 
        :key="item.id"
        @change="() => collapseChange(item)" 
        accordion>
            <van-collapse-item :name="orgData.id">
                <span slot="icon" :class="getIconStyleClass(orgData.id,item)"></span>
                <span slot="right-icon"></span>
                <div 
                slot="title" 
                class="collapse-title" 
                :style="getCollapseStyle(item)">
                    <span>{{item.org_name}}</span>
                    <van-icon v-show="activeId === item.id" name="success" color="#5A8DFF" size="24px" />
                </div>
                <org-collapse 
                v-if="item.children && item.children.length > 0"
                @dropdownToggle="$emit('dropdownToggle')"
                :orgData="item.children" />
            </van-collapse-item>
        </van-collapse>
    </div>
</template>
<script>
import { Collapse, CollapseItem, Icon } from 'vant';
import store from '../store'
export default {
    name: "org-collapse",
    components: {
        "van-collapse": Collapse,
        "van-collapse-item": CollapseItem,
        "van-icon": Icon
    },
    props: {
        orgData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
        getCollapseStyle() {
            return (item) => {
                if (this.activeId === item.id) {
                    if (item.children && item.children.length > 0) {
                        return 'color:#5A8DFF'
                    } else {
                        return 'color:#5A8DFF;padding-left: 14px;'
                    }
                } else {
                    if (item.children && item.children.length > 0) {
                        return ''
                    } else {
                        return 'padding-left: 14px;'
                    }
                }
            }
        },
        getIconStyleClass() {
            return (activeId,item) => {
                if (item.children && item.children.length > 0) {
                    return 'active-collapse-icon collapse-icon'
                } else {
                    return ''
                }
            }
        },
        activeId() {
            return store.getters.getActiveOrg.id
        }
    },
    methods: {
        collapseChange(item) {
            store.commit('setActiveOrg', item)
            this.$emit('dropdownToggle')
        }
    }

}
</script>
<style lang="scss" scoped>
.org-collapse {
    > .van-collapse {
        ::v-deep .van-cell {
            padding: 5PX 0;
        }
    }

    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border-width: 0 0;
    }
    ::v-deep .van-cell:not(:last-child)::after { 
        border: none;
    }
}
    .collapse-icon {
        position: relative;
        color: #AAAAAA;
    }
    .collapse-icon::before {
        position: absolute;
        top: 50%;
        right: -20PX;
        margin-top: -4PX;
        border: 3PX solid;
        border-color: transparent transparent currentColor currentColor;
        transform: rotate(-135deg);
        opacity: .8;
        content: '';
    }
    .active-collapse-icon::before {
        transform: rotate(-45deg);
        right: -20PX;
        margin-top: -3PX;
    }
    .collapse-title {
        padding-left: 24PX;
        padding-right: 24PX;
        position: relative;
        height: 30PX;
        line-height: 30PX;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 260px;
        }
    }

    .van-collapse {
        ::v-deep .van-collapse-item__content {
            padding: 0;
            padding-left: 10PX;
        }
    }
</style>